var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.tabClasses},[_c('p',{on:{"click":function($event){_vm.appInstall()}}},[_vm._v("install app")]),_c('p',{staticClass:"install-dismiss",on:{"click":function($event){_vm.dismissInstall()}}},[_vm._v("dismiss")])])}
var staticRenderFns = []

export { render, staticRenderFns }